import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import Home from "@/pages/Home";
import Books from "@/pages/Books";
import BookDetail from "@/pages/BookDetail";
import About from "@/pages/About";
import News from "@/pages/News";
import Contact from "@/pages/Contact";
import EllaRaine from "@/pages/EllaRaine";
import Characters from "@/pages/Characters";
import NewsDetail from "@/pages/NewsDetail";
import ScrollToTop from "@/components/ScrollToTop";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <ScrollToTop />
        <Navbar />
        <main>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/books" element={<Books />} />
            <Route path="/books/:slug" element={<BookDetail />} />
            <Route path="/about" element={<About />} />
            <Route path="/news" element={<News />} />
            <Route path="/news/:slug" element={<NewsDetail />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/ella-raine" element={<EllaRaine />} />
            <Route path="/characters" element={<Characters />} />
          </Routes>
        </main>
        <Footer />
        <Toaster
          theme="dark"
          position="bottom-right"
          toastOptions={{
            style: {
              background: "#2B3A4A",
              border: "1px solid rgba(255,255,255,0.1)",
              color: "#fff",
              fontFamily: "Outfit, sans-serif",
            },
            classNames: {
              toast: "site-toast",
              success: "site-toast-success",
              error: "site-toast-error",
            },
            unstyled: false,
          }}
          richColors={false}
          data-testid="toaster"
        />
      </BrowserRouter>
    </div>
  );
}

export default App;
